module.exports = __webpack_public_path__ + "static/img/19.4c3e990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/19.png
// module id = fOSH
// module chunks = 1